"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var svgToUrl = function (svg) { return "url('data:image/svg+xml;charset=utf8,".concat(encodeURIComponent(svg), "')"); };
exports.default = svgToUrl;
//# sourceMappingURL=svg-to-url.js.map